var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusyL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "busyL",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "outerPart"
  }, /*#__PURE__*/React.createElement("g", {
    className: "innerPath3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "BUSY_main_transparent",
    d: "M130.5 88.4c1.4 3.6 2.1 7.5 2.1 11.5v1.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "innerPath2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "BUSY_main_transparent",
    d: "M131.4 108.7c-3 10.9-11.6 19.5-22.4 22.7"
  })), /*#__PURE__*/React.createElement("g", {
    className: "innerPath1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "BUSY_main_transparent",
    d: "M101.8 132.5H100c-18 0-32.6-14.6-32.6-32.6 0-2.3.2-4.4.7-6.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "innerWings"
  }, /*#__PURE__*/React.createElement("path", {
    className: "BUSY_main_fill_transparent",
    d: "M106 93.6c-1.3 2.6-5 3.4-8.2 1.8-.9-.4-1.9-1.2-2.9-2.1.1 1.7-.7 3.2-2.1 3.7-1.8.7-3.9-.6-4.8-2.9-.8-2.2-.7-7.3.3-9.3 3-1.1 10.9-.5 14.1 1.1 3.3 1.7 4.9 5.1 3.6 7.7zM76.7 73.7s0 .1 0 0c-1.9 1.1-7 1.4-9.3.7-2.3-.7-3.6-2.8-3.1-4.6.5-1.4 1.9-2.2 3.6-2.2-.9-1-1.7-2-2.2-2.9-1.7-3.2-1.1-6.9 1.5-8.3 2.6-1.4 6 .1 7.8 3.3 1.8 3.2 2.7 11 1.7 14z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "innerBee"
  }, /*#__PURE__*/React.createElement("path", {
    className: "BUSY_special",
    d: "M68.5 93.9c-1.3-1.2-1-10.7 4.3-16.2l7.6-8c3.1-3.2 8.2-3.3 11.5-.2 3.2 3.1 3.3 8.2.2 11.5l-7.6 8c-5.4 5.7-14.9 5.9-16 4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "BUSY_main",
    d: "M77.2 73.5s2.7 8.1 11.5 11M72.8 78.1s2.7 8.1 11.5 11M69.1 84.1s2 5.8 8.7 8.8M89.3 67.1l1.6-4.2M95.1 72.6l4.1-1.7"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "innerPart"
  }, /*#__PURE__*/React.createElement("g", {
    className: "outerPath3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "BUSY_main_transparent",
    d: "M131.2 159c-9.3 4.9-19.9 7.7-31.1 7.7-3.9 0-7.8-.3-11.5-1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "outerPath2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "BUSY_main_transparent",
    d: "M81.3 164c-27.4-8-47.6-33-48.2-62.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "outerPath1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "BUSY_main_transparent",
    d: "M33.4 93.3c3.2-34.1 31.8-60.7 66.7-60.7 12.8 0 24.7 3.6 34.9 9.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "outerWings"
  }, /*#__PURE__*/React.createElement("path", {
    className: "BUSY_main_fill_transparent",
    d: "M169.9 43.8c-1.3-2.6-5-3.4-8.2-1.8-.9.4-1.9 1.2-2.9 2.1.1-1.7-.7-3.2-2.1-3.7-1.8-.7-3.9.6-4.8 2.9-.8 2.2-.7 7.3.3 9.3 3 1.1 10.9.5 14.1-1.1 3.3-1.6 4.9-5.1 3.6-7.7zM140.7 63.7s-.1 0 0 0c-.1 0 0 0 0 0-1.9-1.1-7-1.4-9.3-.7-2.3.7-3.6 2.8-3.1 4.6.5 1.4 1.9 2.2 3.6 2.2-.9 1-1.7 2-2.2 2.9-1.7 3.2-1.1 6.9 1.5 8.3 2.6 1.4 6-.1 7.8-3.3 1.8-3.1 2.6-11 1.7-14z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "outerBee"
  }, /*#__PURE__*/React.createElement("path", {
    className: "BUSY_special",
    d: "M132.5 43.5c-1.3 1.2-1 10.7 4.3 16.2l7.6 8c3.1 3.2 8.2 3.3 11.5.2 3.2-3.1 3.3-8.2.2-11.5l-7.6-8c-5.5-5.6-15-5.9-16-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "BUSY_main",
    d: "M141.1 63.9s2.7-8.1 11.5-11M136.7 59.3s2.7-8.1 11.5-11M133.1 53.4s2-5.8 8.7-8.8M152.5 70.2l1.6 4.1M158.3 64.6l4.1 1.7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusyL);
export default __webpack_public_path__ + "static/media/busyL.91c456dcfb4a11314fb16bfcc119aaf6.svg";
export { ForwardRef as ReactComponent };